'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _bookingConfirmation = require('../../src/styles/booking-confirmation.scss');

var _bookingConfirmation2 = _interopRequireDefault(_bookingConfirmation);

require('../../src/styles/external.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import messages from '../lang/default-messages';

var BookingConfirmation = function BookingConfirmation(props) {
	return _react2.default.createElement(
		'div',
		{ className: _bookingConfirmation2.default.bookingConfirmation + ' ' + _bookingConfirmation2.default.className },
		_react2.default.createElement(
			'p',
			null,
			'Your booking has been sent to your email and ',
			props.specialistName,
			'.'
		),
		_react2.default.createElement(
			'p',
			null,
			'We have asked ',
			props.specialistName,
			' to confirm your booking with you directly as soon as possible.'
		),
		_react2.default.createElement(
			'div',
			{ className: _bookingConfirmation2.default.appointmentDetails },
			_react2.default.createElement(
				'h1',
				null,
				'Appointment details'
			),
			_react2.default.createElement(
				'p',
				null,
				props.practiceName
			),
			_react2.default.createElement(
				'p',
				null,
				props.appointmentDatetime
			)
		),
		_react2.default.createElement(
			'div',
			{ className: _style2.default.actions },
			_react2.default.createElement(
				'button',
				{ className: 'btn solid', onClick: function onClick() {
						return props.onClose();
					} },
				'Close'
			)
		)
	);
};
// import { FormattedMessage } from 'react-intl';

BookingConfirmation.propTypes = {
	specialistName: require('react').PropTypes.any.isRequired,
	practiceName: require('react').PropTypes.any.isRequired,
	appointmentDatetime: require('react').PropTypes.any.isRequired,
	className: require('react').PropTypes.any,
	onClose: require('react').PropTypes.func.isRequired
};


BookingConfirmation.displayName = 'BookingConfirmation';

exports.default = BookingConfirmation;


// WEBPACK FOOTER //
// ./components/book-appointment/lib/components/booking-confirmation.js